import { FeaturesFlags } from "@/store/features/features";

import { UserSlice } from "../user";
import type { FeatureLimits } from "./slices/limit/models";
import { createFeatureLimitSlice, FeatureLimitSlice } from "./slices/limit";

export type { FeaturesFlags } from "./features";

type ENV = "dev" | "beta" | "prod";

export type FeatureSlice = {
  features: FeaturesFlags;
  hasFeature: (name: keyof FeaturesFlags) => boolean;

  // Is running either on Local or Dev
  isDev: boolean;
  isBeta: boolean;
  isProd: boolean;
  isAdmin: boolean;
} & FeatureLimitSlice;

export function createFeaturesSlice(
  initialState: FeaturesFlags | undefined,
  limits: FeatureLimits | undefined,
  userSlice: UserSlice,
): FeatureSlice {
  // Not a signal as we expect this to never change during client execution
  const features = initialState || {};
  const featureLimitSlice = createFeatureLimitSlice(limits, userSlice);

  return {
    features,
    hasFeature: hasFeature(features),
    isDev: isENV(features, "dev"),
    isBeta: isENV(features, "beta"),
    isProd: isENV(features, "prod"),
    isAdmin: hasFeature(features)("general.admin"),
    ...featureLimitSlice,
  };
}

function hasFeature(features: FeaturesFlags): (name: keyof FeaturesFlags) => boolean {
  return name => !!features[name];
}

function isENV(features: FeaturesFlags, env: ENV): boolean {
  return !!features[`general.${env}`];
}
